
import React from 'react';
import { MIDIMessageData } from '../types';

interface MIDIDebuggerProps {
  message: MIDIMessageData | null;
}

const MIDIDebugger: React.FC<MIDIDebuggerProps> = ({ message }) => {
  if (!message) {
    return (
      <div className="mt-4 p-3 bg-gray-900/50 rounded-lg text-sm text-gray-500 italic text-center" data-debug-id="Level-4:MidiDebugger-WaitingState">
        Waiting for MIDI input...
      </div>
    );
  }
  
  const isNoteOn = message.type === 'Note On';
  const typeColor = isNoteOn ? 'text-green-300' : 'text-red-300';
  const dotColor = isNoteOn ? 'bg-green-400 animate-pulse' : 'bg-red-400';

  return (
    <div className="mt-4 p-3 bg-gray-900/50 rounded-lg text-sm font-mono flex items-center space-x-2" data-debug-id="Level-4:MidiDebugger-ActiveState">
      <div className="flex items-center space-x-2 w-20 flex-shrink-0" data-debug-id="Level-5:MidiDebugger-TypeSection">
        <span className={`w-3 h-3 rounded-full ${dotColor}`} data-debug-id="Level-6:MidiDebugger-StatusDot"></span>
        <span className={`font-bold ${typeColor} text-xs`} data-debug-id="Level-6:MidiDebugger-MessageType">{message.type === 'Note On' ? 'ON' : 'OFF'}</span>
      </div>
      <div className="text-center w-16 flex-shrink-0" data-debug-id="Level-5:MidiDebugger-NoteSection">
        <span className="font-bold text-cyan-400 text-base block" data-debug-id="Level-6:MidiDebugger-NoteName">{message.noteName}</span>
        <span className="text-gray-400 text-xs" data-debug-id="Level-6:MidiDebugger-NoteNumber">({message.note})</span>
      </div>
      <div className="text-center w-12 flex-shrink-0" data-debug-id="Level-5:MidiDebugger-VelocitySection">
        <span className="text-gray-400 text-xs block" data-debug-id="Level-6:MidiDebugger-VelocityLabel">Vel</span>
        <span className="font-bold text-gray-200" data-debug-id="Level-6:MidiDebugger-VelocityValue">{message.velocity}</span>
      </div>
      <div className="text-center w-10 flex-shrink-0" data-debug-id="Level-5:MidiDebugger-ChannelSection">
        <span className="text-gray-400 text-xs block" data-debug-id="Level-6:MidiDebugger-ChannelLabel">Ch</span>
        <span className="font-bold text-gray-200" data-debug-id="Level-6:MidiDebugger-ChannelValue">{message.channel}</span>
      </div>
    </div>
  );
};

export default MIDIDebugger;
